import React from 'react';
import { useTranslation } from 'react-i18next';
import {
    DrawerActionTrigger,
    DrawerBackdrop,
    DrawerBody,
    DrawerCloseTrigger,
    DrawerContent,
    DrawerFooter,
    DrawerHeader,
    DrawerRoot,
    DrawerTitle,
    DrawerTrigger,
} from './ui/drawer';
import { Button, List, Separator, Tabs } from '@chakra-ui/react';
import { FireFox } from './OperationInstruction/FireFox';
import { Chrome } from './OperationInstruction/Chrome';
import { Edge } from './OperationInstruction/Edge';
import { Text } from './Text';

type Props = {};

export const OperatingInstruction = (props: Props) => {
    const { t } = useTranslation();
    return (
        <DrawerRoot size="lg">
            <DrawerBackdrop />
            {/** @ts-expect-error: Let's ignore a compile error */}
            <DrawerTrigger asChild>
                <Button variant="outline" size="sm" rounded="lg" fontWeight="600" bg="light.100" borderColor="brand.100" color="brand.100">
                    {t('operatingInstructions')}
                </Button>
            </DrawerTrigger>
            {/** @ts-expect-error: Let's ignore a compile error */}
            <DrawerContent>
                <DrawerHeader>
                    <DrawerTitle>{t('operatingInstructions')}</DrawerTitle>
                </DrawerHeader>
                <DrawerBody>
                    <Tabs.Root defaultValue="firefox" textStyle="md" mb={4}>
                        <Tabs.List>
                            {/** @ts-expect-error: Let's ignore a compile error */}
                            <Tabs.Trigger textStyle="md" value="firefox">
                                FireFox
                            </Tabs.Trigger>
                            {/** @ts-expect-error: Let's ignore a compile error */}
                            <Tabs.Trigger textStyle="md" value="chrome">
                                Chrome
                            </Tabs.Trigger>
                            {/** @ts-expect-error: Let's ignore a compile error */}
                            <Tabs.Trigger textStyle="md" value="edge">
                                Edge
                            </Tabs.Trigger>
                        </Tabs.List>
                        {/** @ts-expect-error: Let's ignore a compile error */}
                        <Tabs.Content value="firefox">
                            <FireFox />
                        </Tabs.Content>
                        {/** @ts-expect-error: Let's ignore a compile error */}
                        <Tabs.Content value="chrome">
                            <Chrome />
                        </Tabs.Content>
                        {/** @ts-expect-error: Let's ignore a compile error */}
                        <Tabs.Content value="edge">
                            <Edge />
                        </Tabs.Content>
                    </Tabs.Root>
                    <Separator />
                    <Text
                        mt={4}
                        trans="operatingInstructionsScreen.collectData.title"
                        fontWeight="semibold"
                        textStyle="lg"
                    />
                    <List.Root as="ol" textStyle="md" mb={4}>
                        <List.Item _marker={{ color: 'inherit' }}>
                            {t('operatingInstructionsScreen.collectData.start.one')}
                        </List.Item>
                        <List.Item _marker={{ color: 'inherit' }}>
                            {t('operatingInstructionsScreen.collectData.start.two')}
                        </List.Item>
                        <List.Item _marker={{ color: 'inherit' }}>
                            {t('operatingInstructionsScreen.collectData.start.three')}
                        </List.Item>
                        <List.Item _marker={{ color: 'inherit' }}>
                            {t('operatingInstructionsScreen.collectData.data.info')}
                            <List.Root ps="4" textStyle="md">
                                <List.Item _marker={{ color: 'inherit' }}>
                                    {t('operatingInstructionsScreen.collectData.data.transaction_0')}
                                    <List.Root as="ol" ps="4" textStyle="md">
                                        <List.Item _marker={{ color: 'inherit' }}>
                                            {t('operatingInstructionsScreen.collectData.data.transactions_1')}
                                        </List.Item>
                                        <List.Item _marker={{ color: 'inherit' }}>
                                            {t('operatingInstructionsScreen.collectData.data.transactions_2')}
                                        </List.Item>
                                    </List.Root>
                                </List.Item>
                                <List.Item _marker={{ color: 'inherit' }}>
                                    {t('operatingInstructionsScreen.collectData.data.share_0')}
                                    <List.Root as="ol" ps="4" textStyle="md">
                                        <List.Item _marker={{ color: 'inherit' }}>
                                            {t('operatingInstructionsScreen.collectData.data.share_1')}
                                        </List.Item>
                                    </List.Root>
                                </List.Item>
                                <List.Item _marker={{ color: 'inherit' }}>
                                    {t('operatingInstructionsScreen.collectData.data.contracts_0')}
                                    <List.Root as="ol" ps="4" textStyle="md">
                                        <List.Item _marker={{ color: 'inherit' }}>
                                            {t('operatingInstructionsScreen.collectData.data.contracts_1')}
                                        </List.Item>
                                    </List.Root>
                                </List.Item>
                            </List.Root>
                        </List.Item>
                        <List.Item _marker={{ color: 'inherit' }}>
                            {t('operatingInstructionsScreen.collectData.data.all')}
                        </List.Item>
                        <List.Item _marker={{ color: 'inherit' }}>
                            {t('operatingInstructionsScreen.collectData.data.export')}
                        </List.Item>
                        <List.Item _marker={{ color: 'inherit' }}>
                            {t('operatingInstructionsScreen.collectData.logout')}
                        </List.Item>
                    </List.Root>
                    <Text trans="operatingInstructionsScreen.saveFile.title" fontWeight="semibold" textStyle="lg" />
                    <List.Root ps="4" textStyle="md">
                        <List.Item _marker={{ color: 'inherit' }}>
                            {`FireFox: ${t('operatingInstructionsScreen.saveFile.firefox')}`}
                        </List.Item>
                        <List.Item _marker={{ color: 'inherit' }}>
                            {`Chrome: ${t('operatingInstructionsScreen.saveFile.chrome')}`}
                        </List.Item>
                        <List.Item _marker={{ color: 'inherit' }}>
                            {`Edge: ${t('operatingInstructionsScreen.saveFile.edge')}`}
                        </List.Item>
                    </List.Root>
                </DrawerBody>
                <DrawerCloseTrigger />
            </DrawerContent>
        </DrawerRoot>
    );
};
